module.exports = __webpack_public_path__ + "img/check-gray.7ddf90d2.svg";